module.exports = __webpack_public_path__ + "static/media/hi-loft-flex.e335e18b.svg";